import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import ProfilePage from './pages/ProfilePage';
import EditProfilePage from './pages/EditProfilePage';
import BookingsPage from './pages/BookingsPage';
import EnhancedBookingPage from './pages/EnhancedBookingPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import BookingAdminPage from './pages/BookingAdminPage';
import AdminInvoicePage from './pages/AdminInvoicePage';
import AdminRoute from './components/AdminRoute';
import AdminRedirectWrapper from './components/AdminRedirectWrapper';
import BookingConfirmation from './pages/BookingConfirmation';
import PaymentFailure from './pages/PaymentFailure';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <AdminRedirectWrapper>
          <div className="App">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/profile/edit" element={<EditProfilePage />} />
              <Route path="/bookings" element={<BookingsPage />} />
              <Route path="/booking" element={<EnhancedBookingPage />} />
              <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/booking-confirmation" element={<BookingConfirmation />} />
              <Route path="/payment-failure" element={<PaymentFailure />} />
              <Route path="/admin/dashboard" element={
                <AdminRoute>
                  <AdminDashboardPage />
                </AdminRoute>
              } />
              <Route path="/admin/booking-admin" element={
                <AdminRoute>
                  <BookingAdminPage />
                </AdminRoute>
              } />
              <Route path="/admin/invoice" element={
                <AdminRoute>
                  <AdminInvoicePage />
                </AdminRoute>
              } />
            </Routes>
          </div>
        </AdminRedirectWrapper>
      </Router>
    </AuthProvider>
  );
}

export default App;
